// extracted by mini-css-extract-plugin
export default {"stat-card":"BiddersRefundRequestStatus_stat-card__NNCDU","stats-container":"BiddersRefundRequestStatus_stats-container__sYVwD"};